module.exports = __webpack_public_path__ + "img/1527464835.4b3711f3.jpg";